import { type ImageContentHighlight } from 'types/studio/studio';

type BgColorDark = NonNullable<Pick<ImageContentHighlight, 'backgroundDark'>['backgroundDark']>;

type BgColorLight = NonNullable<Pick<ImageContentHighlight, 'backgroundLight'>['backgroundLight']>;

type BgColorClassName = `${BgColorDark}Bg` | `${BgColorLight}Bg`;

type Props = {
  isDarkMode: boolean;
} & Pick<ImageContentHighlight, 'backgroundDark' | 'backgroundLight'>;

export const getBgColorClassName = ({
  isDarkMode,
  backgroundDark,
  backgroundLight
}: Props): BgColorClassName => {
  let classNameDark: BgColorClassName = 'greenBg'; // default dark
  let classNameLight: BgColorClassName = 'whiteBg'; // default light

  if (backgroundDark) classNameDark = `${backgroundDark}Bg`;
  if (backgroundLight) classNameLight = `${backgroundLight}Bg`;

  return isDarkMode ? classNameDark : classNameLight;
};
